package com.mps.asc_app.domain.places.usecase

import com.mps.asc_app.data.places.GooglePlacesRepository
import com.mps.asc_app.domain.places.mapper.toAddress
import com.mps.asc_app.domain.places.model.Address

class ValidateAddressUseCase(
    private val repository: GooglePlacesRepository
) {

    suspend operator fun invoke(placeId: String): Address? {
        val response = repository.fetchPlaceDetails(placeId)
        return response.result?.toAddress()
    }
}